// extracted by mini-css-extract-plugin
export default {"uploadIcon":"StreetImportTab_uploadIcon__RuTsG","space":"StreetImportTab_space__tm25Y","uploadSpace":"StreetImportTab_uploadSpace__li-K8"};